import { FC } from 'react';
import AccordionContent from 'ui-kit/components/accordion/AccordionContent';
import PartyForm from '../components/PartyForm';
import { PartyAccordionProps } from '../types';

const PartyAccordion: FC<PartyAccordionProps> = ({
  party,
  transfereeIndex,
  partyIndex,
  transfereeType,
  expanded,
  onExpand,
  onUpdate,
  onDelete,
  validationErrors,
  clearValidationErrors,
}) => {
  const handleDelete = () => {
    onDelete(transfereeIndex, partyIndex);
  };

  return (
    <AccordionContent
      id={party.id || `party-${transfereeIndex}-${partyIndex}`}
      title={`Party No. ${partyIndex + 1}`}
      expanded={true}
      hideSubtitle={true}
      icon="person"
      data-testid={`fincen-party-${transfereeIndex}-${partyIndex}-accordion`}
      data-testid-edit={`fincen-party-${transfereeIndex}-${partyIndex}-edit-button`}
      data-testid-delete={`fincen-party-${transfereeIndex}-${partyIndex}-delete-button`}
      onDelete={partyIndex === 0 ? undefined : handleDelete}
      subtitle={[]}
    >
      <PartyForm
        party={party}
        transfereeType={transfereeType}
        transfereeIndex={transfereeIndex}
        partyIndex={partyIndex}
        onUpdate={onUpdate}
        validationErrors={validationErrors}
        clearValidationErrors={clearValidationErrors}
      />
    </AccordionContent>
  );
};

export default PartyAccordion;
